import { SizePrimitives } from '@front/model'

export const MOBILE_CONTROL_HEIGHT = SizePrimitives['12']
